import { z } from "zod";

/**
 * ReportContasPagarAnaliticoSchema
 */

export const ReportContasReceberAnaliticoColumnsSchema = z.object({
    nroContasPagar: z.boolean().default(false),
    centroCusto: z.boolean().default(false),
    bancoPagamento: z.boolean().default(false),
    notaFiscal: z.boolean().default(false),
    nroDocumento: z.boolean().default(false),
    status: z.boolean().default(false),
    titulo: z.boolean().default(false),
    dataPagar: z.boolean().default(false),
    dataPago: z.boolean().default(false),
    valorPagar: z.boolean().default(false),
    valorPago: z.boolean().default(false),
    observacao: z.boolean().default(false),
    subconta: z.boolean().default(false),
    cliente: z.boolean().default(false),
    nroContratoFinanceiro: z.boolean().default(false),
    multa: z.boolean().default(false),
    juros: z.boolean().default(false),
    desconto: z.boolean().default(false),
    bdi: z.boolean().default(false),
    bdi2: z.boolean().default(false),
    bdiTotal: z.boolean().default(false),
    bdiTotal2: z.boolean().default(false),
    dataCriacao: z.boolean().default(false),
    dataCompetencia: z.boolean().default(false),

});



/**
 * ReportContasReceberAnaliticoSchema
 */
export const ReportContasReceberAnaliticoSchema = z.object({
    requiredMimeType: z.string().optional().nullable(),
    centroCusto: z.array(z.number()).nullable().default(null),
    titulo: z.coerce.string().optional().nullable(),
    dataReceberDe: z.coerce.date().optional().nullable(),
    dataReceberAte: z.coerce.date().optional().nullable(),
    dataRecebidoDe: z.coerce.date().optional().nullable(),
    dataRecebidoAte: z.coerce.date().optional().nullable(),
    status: z.array(z.number()).nullable().default(null),
    tipoConta: z.array(z.number()).nullable().default(null), //banco pagamento
    idUsuario: z.coerce.number().int().optional().nullable(),
    subconta: z.array(z.number()).nullable().default(null),
    cliente: z.array(z.number()).nullable().default(null),
    nroContratoFinanceiro: z.coerce.number().int().optional().nullable(),
    dataCriacaoDe: z.coerce.date().optional().nullable(),
    dataCriacaoAte: z.coerce.date().optional().nullable(),
    dataCompetenciaDe: z.coerce.date().optional().nullable(),
    dataCompetenciaAte: z.coerce.date().optional().nullable(),
    ordenacao: z.coerce.number().optional().nullable().default(0),
    colunas: ReportContasReceberAnaliticoColumnsSchema,

});

/**
 * ReportContasReceberAnaliticoForm
 */

export type ReportContasReceberAnaliticoForm = z.infer<typeof ReportContasReceberAnaliticoSchema>;

export type ReportContasReceberAnaliticoColumnsForm = z.infer<typeof ReportContasReceberAnaliticoColumnsSchema>;

export const defaultReportContasReceberAnaliticoForm: ReportContasReceberAnaliticoForm = {
    requiredMimeType: null,
    centroCusto: null,
    titulo: null,
    dataReceberDe: null,
    dataReceberAte: null,
    dataRecebidoDe: null,
    dataRecebidoAte: null,
    status: null,
    tipoConta: null,
    idUsuario: null,
    subconta: null,
    cliente: null,
    nroContratoFinanceiro: null,
    dataCriacaoDe: null,
    dataCriacaoAte: null,
    dataCompetenciaDe: null,
    dataCompetenciaAte: null,
    ordenacao: 0,
    colunas: {
        nroContasPagar: true,
        centroCusto: true,
        bancoPagamento: true,
        notaFiscal: true,
        nroDocumento: true,
        status: true,
        titulo: true,
        dataPagar: true,
        dataPago: true,
        valorPagar: true,
        valorPago: true,
        observacao: true,
        subconta: true,
        cliente: true,
        nroContratoFinanceiro: true,
        multa: true,
        juros: true,
        desconto: true,
        bdi: true,
        bdi2: true,
        bdiTotal: true,
        bdiTotal2: true,
        dataCriacao: true,
        dataCompetencia: true

    }
};